import React from 'react';
import { Tabs } from '../../../Components/Tabs/Tabs';
import { Filter } from '../../../Components/Filter/Filter';
import { Button } from '../../../Components/Button/Button';
import { Icons } from '../../../Components/Icons/Icons';
import { USER_TABS } from '../constants';
import { TabId, FilterOption, AuthUser } from '../types';
import { UserRole } from '../../../api/users';
import clsx from 'clsx';

interface UsersHeaderProps {
  userData: AuthUser | null;
  activeTab: TabId;
  onTabChange: (tabId: string) => void;
  filterOptions: FilterOption[];
  filterBy: string;
  onFilterChange: (value: string) => void;
  selectedUsers: number[];
  onDeleteAll: () => void;
  onAddUser: () => void;
}

export const UsersHeader: React.FC<UsersHeaderProps> = ({
  userData,
  activeTab,
  onTabChange,
  filterOptions,
  filterBy,
  onFilterChange,
  selectedUsers,
  onDeleteAll,
  onAddUser,
}) => {
  return (
    <>
      <h1>User's Data</h1>
      {userData?.role === UserRole.ADMIN && (
        <Tabs<TabId> tabs={USER_TABS} activeTab={activeTab} onTabChange={onTabChange} />
      )}
      <div className="page-header">
        <Filter
          hidden={filterOptions.length === 1}
          options={filterOptions}
          value={filterBy}
          onChange={onFilterChange}
          placeholder="Agency"
        />
        <div className="btns">
          <div
            className={clsx('delete-all', {
              show: selectedUsers.length > 0,
            })}
            onClick={onDeleteAll}
          >
            {Icons.Delete} Delete All
          </div>
          <Button variant="button" onClick={onAddUser}>
            {Icons.WhitePlus} Add New User
          </Button>
        </div>
      </div>
    </>
  );
};
